import type { StyleProps } from '@chakra-ui/react';
import { Box, useColorModeValue, Skeleton, Image } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';
import IconSvg from 'ui/shared/IconSvg';
// import Image from 'next/image';

interface Props {
  isCollapsed?: boolean;
  onClick?: (event: React.SyntheticEvent) => void;
  imageProps?: StyleProps;
}

const LogoFallback = ({ isCollapsed, isSmall, imageProps }: { isCollapsed?: boolean; isSmall?: boolean; imageProps?: StyleProps }) => {
  const field = isSmall ? 'icon' : 'logo';
  const logoColor = useColorModeValue('blue.600', 'white');

  const display = isSmall ? {
    base: 'none',
    lg: isCollapsed === false ? 'none' : 'block',
    xl: isCollapsed ? 'block' : 'none',
  } : {
    base: 'block',
    lg: isCollapsed === false ? 'block' : 'none',
    xl: isCollapsed ? 'none' : 'block',
  };

  if (config.UI.sidebar[field].default) {
    return <Skeleton w="100%" borderRadius="sm" display={ display }/>;
  }

  return (
    <IconSvg
      name={ isSmall ? 'networks/icon-placeholder' : 'networks/logo-placeholder' }
      width="auto"
      height="100%"
      color={ logoColor }
      display={ display }
      { ...imageProps }
    />
  );
};

const NetworkLogo = ({ isCollapsed, onClick, imageProps }: Props) => {

  return (
    <Box
      as="a"
      href={ route({ pathname: '/' }) }
      width={{ base: '220px', lg: '300px' }}
      height={{ base: '55px', lg: '70px' }}
      display="inline-flex"
      justifyContent="flex-start"
      margin="0"
      overflow="hidden"
      onClick={ onClick }
      flexShrink={ 0 }
      aria-label="Link to main page"
    >
      <Image
        src="/static/network_logo.png"
        alt={`${ config.chain.name } network logo`}
        height="auto"
        maxH="100%"
        objectFit="contain"
        display="block"
        { ...imageProps }
        margin="0"
      />
    </Box>
  );
};

export default React.memo(NetworkLogo);
